var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0538 12.4285C21.0522 12.9318 21.0045 13.4339 20.9113 13.9285C20.582 15.7898 19.6488 17.4908 18.2559 18.7686C16.863 20.0465 15.0881 20.83 13.2053 20.9981C11.3226 21.1662 9.43693 20.7095 7.83973 19.6986C6.24254 18.6877 5.02277 17.1788 4.36893 15.4053C3.71509 13.6318 3.66359 11.6923 4.22239 9.88652C4.78119 8.08078 5.91918 6.50937 7.46048 5.41513C9.00177 4.3209 10.8606 3.76477 12.7496 3.83271C14.6386 3.90064 16.4526 4.58885 17.9113 5.79098L15.7963 7.92848C14.8278 7.19387 13.6444 6.79852 12.4288 6.80348C11.3806 6.8023 10.3529 7.09404 9.46167 7.64578C8.57043 8.19753 7.85108 8.98733 7.38477 9.9261C6.91846 10.8649 6.72373 11.9153 6.82256 12.9588C6.92139 14.0024 7.30984 14.9975 7.94409 15.8321C8.57834 16.6666 9.43317 17.3073 10.4121 17.682C11.3911 18.0566 12.4553 18.1502 13.4847 17.9523C14.514 17.7544 15.4676 17.2727 16.2378 16.5618C17.008 15.8508 17.5643 14.9387 17.8438 13.9285H12.8038V10.9285H20.9113C21.0007 11.4236 21.0483 11.9254 21.0538 12.4285Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.b772d5a6.svg";
export { ForwardRef as ReactComponent };